// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc29d79e","455":"7d4e3eb1","977":"07fc4b7a"}[chunkId] + ".chunk.js";
};